import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { SplitSheetModalService } from '../../services/split-sheet-modal.service';

@Component({
  selector: 'split-sheet-modal',
  templateUrl: './split-sheet-modal.component.html',
  styleUrls: ['./split-sheet-modal.component.scss']
})
export class SplitSheetModalComponent implements OnChanges, OnDestroy {
  @Input() isShow: boolean = false;
  @Output() isShowChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() loading: boolean = false;


  @Input() name!: string;
  isChildren: boolean = false;
  constructor(private splitSheetModalService: SplitSheetModalService) {

  }

  ngOnDestroy(): void {
    let position = this.splitSheetModalService.modals.indexOf(this.name);
    this.splitSheetModalService.modals.splice(position, 1);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['name']) {
      this.splitSheetModalService.modals.push(this.name);
      this.splitSheetModalService.modalSubject.subscribe(
        (nav: any) => {
          console.log(nav);
          let data =  nav.data;
          if(nav.action == "CLOSE") {
            this.isShow = false;
          } else {
            let position = data.indexOf(this.name);

            if(position > 0) {
              this.isChildren = true;
            }

            if(data[data.length - 1] == this.name) {
              this.isShow = true;
            } else {
              this.isShow = false;
            }
          }
        }
      );
    }
  }

  hideModal() {
    this.splitSheetModalService.close(this.name);

    /*this.isShow = false;
    this.isShowChange.emit(this.isShow);*/
  }

  popModal() {
    this.splitSheetModalService.pop();
  }
}
